const Svg = ({ width = 24 }: { width: number }) => (
  <svg
    width={width}
    height={(width / 24) * 20}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1H23" stroke="#EBDCD5" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M1 10.3077H23"
      stroke="#EBDCD5"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M1 18.7692H23"
      stroke="#EBDCD5"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export default Svg;
